/** What the Designer's release list and the control center's both say about a release. */

export default {
	releases: {
		changelog: {
			title: "Änderungen",
			added: "Hinzugefügt",
			changed: "Geändert",
			removed: "Entfernt",
			empty: "Keine Änderungen am Modell.",
		},
		origin: {
			local: "Hier erstellt",
			imported: "Importiert",
		},
		build: {
			available: "Ausführbar",
			availableNote:
				"Sein Build liegt auf diesem Server, ein Dataspace kann es also ausführen.",
			missing: "Kein Build",
			missingNote:
				"Sein Build liegt nicht auf diesem Server, kein Dataspace kann es also ausführen.",
		},
		export: {
			action: "Exportieren",
			label: "{version} exportieren",
			buildMissing:
				"Der Build dieses Releases ist nicht mehr auf dem Server und kann daher nicht exportiert werden.",
		},
	},
};
